import Vue from 'vue'

function broadcast(componentName, eventName, params) {
  this.$children.forEach(child => {
    const name = child.$options.name;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      // todo 如果 params 是空数组，接收到的会是 undefined
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}

export function addUtil(key, instance) {
  window.Vue.prototype[key] = instance
  window.Vue[key] = instance
  window[key] = instance
}

export class VueUtil {
  constructor(router, store) {
    this.router = router
    this.store = store
  }
  vueName(type) {
    const name = type.sealedOptions
      ? type.sealedOptions.name
      : type.name

    return name
      ? name[0].toUpperCase() + name.substr(1).toLowerCase()  // title case
      : 'Anonymous'
  }
  // go back
  goBack (defpath='/home') {
    if (window.history.length > 1) {
      this.router.go(-1)
    } else {
      this.router.push(defpath)
    }
  }
  dispatch(vm, componentName, eventName, params) {
    let parent = vm.$parent || vm.$root;
    let name = parent.$options.name;

    while (parent && (!name || name !== componentName)) {
      parent = parent.$parent;

      if (parent) {
        name = parent.$options.name;
      }
    }
    if (parent) {
      parent.$emit.apply(parent, [eventName].concat(params));
    }
  }
  broadcast(vm, componentName, eventName, params) {
    broadcast.call(vm, componentName, eventName, params);
  }
}

export class ComponentUtil {
  constructor(store) {
    this.store = store
  }
  create({ cls, clsprops={} }) {
    return this.__create({cls, clsprops})
  }
  createCustom({ render, vueprops={} }) {
    return this.__create({vueprops, render})
  }
  __create({cls = null, clsprops = {}, vueprops = {}, render = null}) {
    let vobj = null
    if (!('store' in vueprops)) {
      vueprops['store'] = this.store
    }
    vueprops = Object.assign(vueprops, {
      render(h) {
        let vnode = this
        if (render) {
          vobj.instance = render(h, vnode)
        } else {
          vobj.instance = h(cls, {
            props: clsprops
          })
        }
        return vobj.instance
      },
      methods: {
        close() {
          this.$emit('onClose', vobj.instance, this)
        }
      },
    })
    vobj = new Vue(vueprops)
    const component = vobj.$mount()
    document.body.appendChild(component.$el)
    vobj.$on('onClose', function() {
      if (component.$el.parentNod) {
        document.body.removeChild(component.$el)
      }
    })
    return vobj
  }
}



// WEBPACK FOOTER //
// ./src/plugins/jscom/jscom/utils/vueutil.js